import { useEffect, useRef } from 'react';

export const useInterval = (callback: () => void, delay: number, runOnce?: boolean) => {
  const savedCallback = useRef<any | null>(null);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    const tick = () => {
      savedCallback.current();
    };
    if (delay !== null) {
      if (runOnce) {
        const id = setTimeout(tick, delay);
        return () => clearTimeout(id);
      }
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay, runOnce]);
};
